module.exports = __webpack_public_path__ + "media/images/pc/plans/inclusion_04-8576e14d25a5efc6973ab4496011c33f.png";